export var TablePaginationTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        // selectLabel: {
        //     display: "none"
        // },
        root: {
            '.MuiToolbar-root': {
                padding: 0,
                minHeight: 0,
            },
        },
        selectRoot: {
            order: 3,
            marginRight: 0,
            marginLeft: 0,
        },
        select: {
            '&.MuiSelect-select.MuiTablePagination-select.MuiInputBase-input': {
                // minHeight: 40,
                paddingLeft: 16,
                paddingRight: 40,
                border: "1px solid ".concat(theme.palette.greySecondary[300]),
                borderRadius: 2,
                '&[aria-expanded="true"]': {
                    borderColor: theme.palette.primary.main,
                },
            },
        },
        selectIcon: {
            marginRight: 8,
        },
        input: {
            fontWeight: "normal",
        },
        actions: {
            marginLeft: 2,
        },
        displayedRows: {
            fontSize: theme.typography.body1.fontSize,
            fontWeight: "normal",
            margin: 0,
        },
    },
}); };
export default TablePaginationTheme;
//# sourceMappingURL=theme.js.map